import { useMemo as r, Children as e, isValidElement as n } from "react";

const o = o => r((() => e.map(o, (r => {
    if (!n(r)) return null;
    switch (typeof r.props.value) {
      case "string":
      case "number":
        break;

      default:
        return "production" !== process.env.NODE_ENV && console.warn("Tabs children value must be a string or a number. Ignoring this one: ", {
            child: r
        }), null;
    }
    return r.props;
})).filter(Boolean)), [ o ]);

export { o as default };
//# sourceMappingURL=index.js.map
